export default {
  title: {
    home: 'Inicio',
    notFound: 'No encontrada',
    error: 'Error',
    legal: 'Legales'
  },
  message: {
    noCampaigns: 'Aún no hay campañas asociadas para el cliente {customerName}',
    specialDayOfferTitle: 'Contrata tu renting ahora y llévate una tarjeta carburante de 150€.',
    specialDayFuelCardTitle450:
      'Contrata tu renting ahora y llévate una tarjeta carburante de 450€.',
    specialDayOfferTitleRedrive:
      'Contrata tu renting ahora y llévate una tarjeta carburante de 500€.',
    specialDaySpecialCampaingOfferTitle:
      'Contrata tu renting ahora y llévate una tarjeta carburante de 60€.',
    specialDayOfferTitle2: 'Solo durante este mes.',
    specialDayQuote:
      'Tarjeta carburante SOLRED que podrá utilizar en las EE.SS. de Repsol, Campsa y Petronor.',
    specialDayDetailTitle: 'Contrata tu renting ahora y llévate una tarjeta carburante de 150€.',
    specialDayDetailTitleRedrive:
      'Contrata tu renting ahora y llévate una tarjeta carburante de 500€.',
    specialDayDetailSpecialCampaingTitle:
      'Contrata tu renting ahora y llévate una tarjeta carburante de 60€.',
    warning: {
      visibilityDate: '¡Sólo hasta el {date}!'
    },
    generic: {
      loadingData: 'Cargando datos'
    }
  },
  language: {
    en: 'Inglés',
    es: 'Español'
  },
  ui: {
    button: {
      btnBack: 'Volver',
      btnSave: 'Guardar',
      btnCancel: 'Cancelar',
      btnAccept: 'Aceptar',
      btnClose: 'Cerrar',
      btnCreate: 'Crear',
      btnConfirm: 'Confirmar',
      btnChange: 'Cambiar',
      btnDelete: 'Eliminar',
      btnRecord: 'Grabar',
      btnClear: 'Limpiar',
      btnCallus: 'Llámanos',
      btnResetFilters: 'Eliminar filtros'
    },
    label: {
      typeVehicle: 'Tipo de oferta',
      mark: 'Marca',
      modelName: 'Modelo',
      province: 'Provincia',
      bodyStyleVehicle: 'Tipo de carrocería',
      typeFuel: 'Tipo de Combustible',
      emissionsFilter: 'Filtro de emisiones',
      term: 'Plazo (meses)',
      kilometers: 'Kilometraje',
      rangePrice: 'Rango de precios',
      onlineContract: 'Contrato online',
      moreInfo: 'Quiero más información',
      termInMonths: 'Plazo',
      months: 'meses',
      yearKms: 'Km/año',
      km: 'Km',
      euro: '€',
      timeMonth: '/mes',
      iva: 'IVA',
      ivaIncluded: 'IVA INCLUIDO',
      igcIncluded: 'IGIC INCLUIDO',
      ivaNotIncluded: 'IVA NO INCLUIDO',
      igcNotIncluded: 'IGIC NO INCLUIDO',
      initialPayment: 'Aportación inicial',
      campaignValidIVA: 'Oferta válida en Península y Baleares hasta el {date}',
      campaignValidIGC: 'Oferta válida en Canarias hasta el {date}',
      igic: 'IGIC',
      deposit: 'Fianza',
      offert: 'Oferta:'
    },
    select: {
      noResultPrincing: 'No hay más opciones'
    },
    placeholder: {}
  },
  error: {
    undefined: 'Ups... ¡Algo salió mal!',
    notFound: 'Esta página no existe',
    campaignNotFound: 'No hemos encontrado la campaña'
  },
  success: {}
};
